import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AuthContext } from "shared/context/auth-context";
import "./NavLinks.css";
import { PERMISSION_TYPES, isCustomerContactRole } from "@routebot/constants";
import { isAdminOrImpersonating } from "shared/util/auth/adminAccess";
import { canOperateCustomerPortal } from "features/customer-portal/access";
import CustomerPortalNavBadge from "features/customer-portal/CustomerPortalNavBadge";

const NavLinks = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);

  let schoolsLinkHeader = "...";

  schoolsLinkHeader = t("clients");

  if (auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_TRACK_VEHICLE_ONLY]) {
    return (
      <ul className="nav-links">
        <li>
          <NavLink to="/live" end>
            {t("watchVehicle")}
          </NavLink>
        </li>
      </ul>
    );
  }

  if (auth.isLoggedIn && isCustomerContactRole(auth.client?.role)) {
    return (
      <ul className="nav-links">
        <li>
          <NavLink to="/portal/requests">{t("customerPortal.navContact")}</NavLink>
        </li>
      </ul>
    );
  }

  return (
    <ul className="nav-links">
      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_USERS] && (
        <li>
          <NavLink to="/users" end>
            {t("usersLinkHeader")}
          </NavLink>
        </li>
      )}

      {/* Simdilik duraklar yok */}
      {auth.isLoggedIn &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_STOPS] && (
          <li>
            <NavLink to="/stops" end>
              {t("stops")}
            </NavLink>
          </li>
        )}

      {/* {auth.isLoggedIn &&
        (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS] && (
          <li>
            <NavLink to="/students" end>
              {studentsLinkHeader}
            </NavLink>
          </li>
        )} */}

      {/* {auth.isLoggedIn &&
        (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_NOTIFICATIONS] && (
          <li>
            <NavLink to="/notifications" end>
              {t("notifications")}
            </NavLink>
          </li>
        )} */}

      {/* {auth.isLoggedIn &&
        (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS] && (
          <li>
            <NavLink to="/vehicleroutes" end>
              {t("vehicleRoutes")}
            </NavLink>
          </li>
        )} */}

      {auth.isLoggedIn &&
        (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] ||
          auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) && (
          <li>
            <NavLink to="/services" end>
              {t("services")}
            </NavLink>
          </li>
        )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_TRANSFERS] && (
        <li>
          <NavLink to="/transfers" end>
            {t("transfers")}
          </NavLink>
        </li>
      )}

      {auth.isLoggedIn &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_SHIFTS] && (
          <li>
            <NavLink to="/shifts" end>
              {t("shifts")}
            </NavLink>
          </li>
        )}

      {auth.isLoggedIn &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] &&
        auth.permissions[PERMISSION_TYPES.ACCESS_TO_SHIFTS] && (
          <li>
            <NavLink to="/shiftmanagement" end>
              {t("shiftmanagement")}
            </NavLink>
          </li>
        )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_WALKING_DISTANCE] && (
        <li>
          <NavLink to="/walking-distance">Yürüme Mesafesi</NavLink>
        </li>
      )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_LIVE] && (
        <li>
          <NavLink to="/live" end>
            {t("watchVehicle")}
          </NavLink>
        </li>
      )}

      {/* Uyarı Merkezi ayrı bir ana menü DEĞİL — Araç İzle (/live) altında Telemetri'nin hemen
          altındaki sekme olarak yaşar (§20, müşteri kararı). */}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_ACCOUNTING] && (
        <li>
          <NavLink to="/accounting" end>
            {t("accounting")}
          </NavLink>
        </li>
      )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_SERVICE_REPORTS] && (
        <li>
          <NavLink to="/analysis" end>
            {t("analysis")}
          </NavLink>
        </li>
      )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_INVENTORY] && (
        <li>
          <NavLink to="/inventory">Envanter</NavLink>
        </li>
      )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_SCHOOLS] && (
        <li>
          <NavLink to="/schools">{t(schoolsLinkHeader)}</NavLink>
        </li>
      )}

      {auth.isLoggedIn && canOperateCustomerPortal(auth) && (
        <li>
          <NavLink to="/customer-requests">
            {t("customerPortal.navOperator")}
            <CustomerPortalNavBadge />
          </NavLink>
        </li>
      )}

      {auth.isLoggedIn && auth.permissions[PERMISSION_TYPES.ACCESS_TO_ADMIN] && (
        <li>
          <NavLink to="/admin">Admin</NavLink>
        </li>
      )}

      {/* Health Checks — yalnızca super_admin login veya admin impersonation oturumu */}
      {auth.isLoggedIn && isAdminOrImpersonating(auth) && (
        <li>
          <NavLink to="/health-checks">Health Checks</NavLink>
        </li>
      )}
    </ul>
  );
};

export default NavLinks;
